(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_offer-cta"] && !Shopify.designMode) return;
  try {
    // <offer-cta-price> custom HTML Element : shows the price of the selected offer in the CTA
  class OfferCtaPrice extends HTMLElement {
    constructor() {
      super();
      this.update = this.update.bind(this);
    }
    connectedCallback() {
      this.offerModule = this.closest('.offer-module');
      if (!this.offerModule) return;
      this.offerModule.addEventListener('change', this.update);
      this.update();
    }
    disconnectedCallback() {
      if (this.offerModule) {
        this.offerModule.removeEventListener('change', this.update);
      }
    }
    update() {
      let selectedOffer = this.offerModule.querySelector('.offer-input:checked');
      let offer = selectedOffer ? selectedOffer.closest('.pack-offer, .offer') : null;
      let price = offer ? offer.querySelector('.pack-price, .offer-price') : null;
      this.textContent = price ? price.textContent.trim() : '';
    }
  }
  customElements.define('offer-cta-price', OfferCtaPrice);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["marquee"] && !Shopify.designMode) return;
  try {
    // <block-marquee> custom HTML Element
  class BlockMarquee extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('block-marquee', BlockMarquee);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["slideshow"] && !Shopify.designMode) return;
  try {
    // <slideshow-component> custom HTML Element
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();

      this.nextSlide = this.nextSlide.bind(this);
      this.prevSlide = this.prevSlide.bind(this);
      this.intervalId = setInterval(this.nextSlide, 5000);

      this.slideIndex = 0;
    }
    connectedCallback() {
      if (this.hasChildNodes()) {
        this.querySelector('.slides').children[0].classList.add('active');
      }
      this.querySelector('.previous').addEventListener("click", this.prevSlide);
      this.querySelector('.next').addEventListener("click", this.nextSlide);
    }
    disconnectedCallback() {
      this.querySelector('.previous').removeEventListener("click", this.prevSlide);
      this.querySelector('.next').removeEventListener("click", this.nextSlide);
    }
    nextSlide() {
      clearInterval(this.intervalId);

      if (this.slideIndex == (this.querySelector('.slides').children.length - 1)) {
        this.slideIndex = 0;
      } else {
        this.slideIndex++;
      }
      for (let i = 0; i < this.querySelector('.slides').children.length; i++) {
        this.querySelector('.slides').children[i].classList.remove('active');
      }
      this.querySelector('.slides').children[this.slideIndex].classList.add('active');

      this.intervalId = setInterval(this.nextSlide, 5000);
    }
    prevSlide() {
      clearInterval(this.intervalId);

      if (this.slideIndex == 0) {
        this.slideIndex = this.querySelector('.slides').children.length - 1;
      } else {
        this.slideIndex--;
      }
      for (let i = 0; i < this.querySelector('.slides').children.length; i++) {
        this.querySelector('.slides').children[i].classList.remove('active');
      }
      this.querySelector('.slides').children[this.slideIndex].classList.add('active');

      this.intervalId = setInterval(this.nextSlide, 5000);
    }
  }
  customElements.define('slideshow-component', SlideshowComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    // <text-underline> custom HTML Element
  class TextUnderline extends HTMLElement {constructor() {super()}}
  customElements.define('text-underline', TextUnderline);

  // <text-accent> custom HTML Element
  class TextAccent extends HTMLElement {constructor() {super()}}
  customElements.define('text-accent', TextAccent);
  
  // <text-tag> custom HTML Element
  class TextTag extends HTMLElement {constructor() {super()}}
  customElements.define('text-tag', TextTag);

  // <timer-component> custom HTML Element
  class TimerComponent extends HTMLElement {
    static get observedAttributes() {
      return ['data-seconds'];
    }

    constructor() {
      super();
      this.remainingSeconds = 0;
      this.interval = null;
    }

    connectedCallback() {
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-seconds' && oldValue !== newValue) {
        this.start();
      }
    }

    start() {
      this.stop();

      const value = this.dataset.seconds;

      if (value === 'midnight') {
        this.remainingSeconds = this.secondsUntilMidnight();
      } else {
        this.remainingSeconds = parseInt(value, 10);
      }

      if (isNaN(this.remainingSeconds) || this.remainingSeconds < 0) return;

      this.render();

      this.interval = setInterval(() => {
        this.remainingSeconds--;

        if (this.remainingSeconds < 0) {
          this.stop();
          return;
        }

        this.render();
      }, 1000);
    }

    stop() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    secondsUntilMidnight() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);

      return Math.floor((midnight - now) / 1000);
    }

    render() {
      const h = Math.floor(this.remainingSeconds / 3600);
      const m = Math.floor((this.remainingSeconds % 3600) / 60);
      const s = this.remainingSeconds % 60;

      this.innerHTML =
        `${String(h).padStart(2, '0')}:` +
        `${String(m).padStart(2, '0')}:` +
        `${String(s).padStart(2, '0')}`;
    }
  }

  customElements.define('timer-component', TimerComponent);
  } catch(e) { console.error(e); }
})();

})();
